import { ChangeNames, YesNo } from "../../clients/FirebaseClient/types";

export const yesNoValue = (
    value: YesNo,
    yesValue = "Ja",
    noValue = "Nein",
    nullValue = "-",
): string => {
    if (value.yes) {
        return yesValue;
    } else if (value.no) {
        return noValue;
    } else {
        return nullValue;
    }
};

type NamingRuleType = {
    change?: string;
    changes?: { change: string }[];
    rules?: {
        condition: {
            [x: string]: boolean;
        };
        name: string;
    }[];
    name?: string;
};

export const NamingRules: NamingRuleType[] = [
    {
        change: ChangeNames.PRODUCT_TYPES,
        rules: [
            {
                condition: {
                    newConnection: true,
                },
                name: "Neuanschluss",
            },
            {
                condition: {
                    modification: true,
                },
                name: "Änderung",
            },
            {
                condition: {
                    removal: true,
                },
                name: "Demontage",
            },
            {
                condition: {
                    charger: true,
                },
                name: "Ladeeinrichtung",
            },
            {
                condition: {
                    increase: true,
                },
                name: "Leistungserhöhung",
            },
            {
                condition: {
                    adjustableLoad: true,
                },
                name: "Verbrauchsgeräte"
            }
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_BUILDING_TYPES,
        rules: [
            {
                condition: {
                    existing: true,
                },
                name: "Bestandsgebäude",
            },
            {
                condition: {
                    new: true,
                },
                name: "Neubau",
            },
        ],
    },
    {
        changes: [
            { change: ChangeNames.NEW_CONNECTION_BUILDING_USAGES },
            { change: ChangeNames.MODIFICATION_BUILDING_USAGES },
            { change: ChangeNames.REMOVAL_RECONSTRUCTION_BUILDING_USAGES },
            { change: ChangeNames.INCREASE_BUILDING_USAGES },
            { change: ChangeNames.ADJUSTABLE_LOAD_BUILDING_USAGE },
        ],
        rules: [
            {
                condition: {
                    business: false,
                    household: true,
                },
                name: "Haushalt",
            },
            {
                condition: {
                    business: true,
                    household: false,
                },
                name: "Gewerbe",
            },
            {
                condition: {
                    business: true,
                    household: true,
                },
                name: "Haushalt und Gewerbe",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_GAS_FEEDS,
        rules: [
            {
                condition: {
                    exterior: true,
                },
                name: "Außenanschluss",
            },
            {
                condition: {
                    interior: true,
                },
                name: "Innenanschluss",
            },
        ],
    },
    {
        change: ChangeNames.REMOVAL_POWER_SUBJECT,
        rules: [
            {
                condition: {
                    cableDisassembly: true,
                },
                name: "Demontage eines in der Erde verlegten Kabels",
            },
            {
                condition: {
                    roofPillarDisassembly: true,
                },
                name: "Demontage eines Dachständers",
            },
        ],
    },
    {
        change: ChangeNames.REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES,
        rules: [
            {
                condition: {
                    power: true,
                    gas: false,
                },
                name: "Strom",
            },
            {
                condition: {
                    power: false,
                    gas: true,
                },
                name: "Gas",
            },
            {
                condition: {
                    power: true,
                    gas: true,
                },
                name: "Strom und Gas",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_BUILDING_TYPES,
        rules: [
            {
                condition: {
                    existing: true,
                },
                name: "Bestandsgebäude",
            },
            {
                condition: {
                    new: true,
                },
                name: "Neubau",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_POWER_FEEDS,
        rules: [
            {
                condition: {
                    exterior: true,
                },
                name: "Außenanschluss",
            },
            {
                condition: {
                    interior: true,
                },
                name: "Innenanschluss",
            },
            {
                condition: {
                    overhead: true,
                },
                name: "Freileitung",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_ROOF_TYPES,
        rules: [
            {
                condition: {
                    flat: true,
                },
                name: "Flachdach",
            },
            {
                condition: {
                    metal: true,
                },
                name: "Metalldach",
            },
            {
                condition: {
                    other: true,
                },
                name: "anderes Dach",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_BUILDING_INTAKES,
        rules: [
            {
                condition: {
                    basePlate: true,
                },
                name: "Bodenplatte",
            },
            {
                condition: {
                    outerWall: true,
                },
                name: "Außenwand des Kellers",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_EXTERIOR_TYPES,
        rules: [
            {
                condition: {
                    connectionPillar: true,
                },
                name: "Hausanschlusssäule",
            },
            {
                condition: {
                    connectionPillarWithMeter: true,
                },
                name: "Zähleranschlusssäule",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES,
        rules: [
            {
                condition: {
                    yes: true,
                },
                name: "Ja",
            },
            {
                condition: {
                    no: true,
                },
                name: "Nein",
            },
            {
                condition: {
                    thirdParty: true,
                },
                name: "anderer Anbieter",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_MULTILINE_VARIANTS,
        rules: [
            {
                condition: {
                    lessOrEqualDa50: true,
                },
                name: "bis einschließlich 50 mm",
            },
            {
                condition: {
                    da63: true,
                },
                name: "63 mm",
            },
        ],
    },
    {
        change: ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL,
        rules: [
            {
                condition: {
                    walled: true,
                },
                name: "Gemauert",
            },
            {
                condition: {
                    doubleWall: true,
                },
                name: "Doppel-/Elementwand",
            },
            {
                condition: {
                    whiteTub: true,
                },
                name: "Weiße Wanne / Vollwand aus WU-Beton",
            },
            {
                condition: {
                    otherWallConstruction: true,
                },
                name: "Sonstiger Wandaufbau",
            },
            {
                condition: {
                    concrete: true,
                },
                name: "Abdichtebene Ortbeton (WU-Beton)",
            },
            {
                condition: {
                    exteriorFormwork: true,
                },
                name: "Abdichtebene Schalung (Außen) ohne zusätzliche Abdichtung auf der Außenwand",
            },
            {
                condition: {
                    onOuterWall: true,
                },
                name: "Abdichtebene auf der Außenwand",
            },
        ],
    },
    {
        change: ChangeNames.MODIFICATION_POWER_FEEDS,
        rules: [
            {
                condition: {
                    cable: true,
                },
                name: "Änderung Kabelnetzanschluss",
            },
            {
                condition: {
                    overhead: true,
                },
                name: "Änderung Freileitung",
            },
        ],
    },
    {
        change: ChangeNames.MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON,
        rules: [
            {
                condition: {
                    defect: true,
                },
                name: "Defekt",
            },
            {
                condition: {
                    other: true,
                },
                name: "Sonstiges",
            },
        ],
    },
    {
        change: ChangeNames.MODIFICATION_POWER_CABLE,
        rules: [
            {
                condition: {
                    junctionBoxRelocation: true,
                },
                name: "Versetzen des Hausanschlusskastens im gleichen Raum (bis 3m)",
            },
            {
                condition: {
                    junctionBoxAndCableRelocation: true,
                },
                name: "Versetzen des Hausanschlusskastens und Umlegung des Netzanschlusskabel inkl. neuer Gebäudeeinführung",
            },
            {
                condition: {
                    cableRelocation: true,
                },
                name: "Umlegung eines Netzanschlusskabels",
            },
            {
                condition: {
                    junctionBoxReplacement: true,
                },
                name: "Austausch Hausanschlusskasten",
            },
        ],
    },
    {
        change: ChangeNames.MODIFICATION_POWER_OVERHEAD,
        rules: [
            {
                condition: {
                    junctionBoxReplacement: true,
                },
                name: "Austausch Hausanschlusskasten",
            },
            {
                condition: {
                    roofPillarReassembly: true,
                },
                name: "Vorübergehender Abbau und Wiedererrichtung eines Dachständers",
            },
            {
                condition: {
                    roofPillarElevation: true,
                },
                name: "Erhöhen eines Dachständers",
            },
        ],
    },
    {
        change: ChangeNames.MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION,
        rules: [
            {
                condition: {
                    same: true,
                },
                name: "An gleicher Stelle",
            },
            {
                condition: {
                    other: true,
                },
                name: "An anderer Stelle",
            },
        ],
    },
];
